
export const replaceGridStylesCss = (css) => {
  const style = document.getElementById('dynamic-css')
  style.innerHTML = css
}

export default {
  replaceGridStylesCss
}
